export default __webpack_public_path__ + "static/media/etoro-logo.96b94567.svg";